$('[data-popover-template]').each((i, el) => {
    const template = $(el).data('popoverTemplate');
    const contentObj = $(template);

    if (contentObj.length) {
        const content = contentObj.html();
        $(el).popover({
            html: true,
            placement: 'bottom',
            content
        });
    }
});
